<ng-template #editProfileModalContent let-c="close" let-d="dismiss">
    <form (ngSubmit)="onSubmit(profileForm)" #profileForm="ngForm">
        <div class="modal-header">
            <h5 class="modal-title" id="modalProfileTitle">{{ 'layout.editProfile.modalTitle' | translate }}</h5>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group col-12">
                <input type="text" [(ngModel)]="profile?.attributes.field_nombre" name="name" id="profile-user-name"
                    class="profile-user-name form-control" placeholder="{{ 'layout.editProfile.name' | translate }}"
                    #name="ngModel" [ngClass]="{ 'is-invalid': profileForm.submitted && name.invalid }" required>
                <div *ngIf="profileForm.submitted && name.invalid" class="invalid-feedback">
                    <div *ngIf="name.errors.required">{{ 'validations.required' | translate }}</div>
                </div>
            </div>
            <div class="form-group col-12">
                <input type="text" [(ngModel)]="profile?.attributes.field_field_apellidos" name="surname"
                    id="profile-user-surname" class="profile-user-surname form-control"
                    placeholder="{{ 'layout.editProfile.surname' | translate }}" #surname="ngModel"
                    [ngClass]="{ 'is-invalid': profileForm.submitted && surname.invalid }" required>
                <div *ngIf="profileForm.submitted && surname.invalid" class="invalid-feedback">
                    <div *ngIf="surname.errors.required">{{ 'validations.required' | translate }}</div>
                </div>
            </div>
            <!--        
            <div class="form-group col-12">
                <input type="text" [(ngModel)]="contactEmail" name="email" id="contact-email" class="contact-email form-control"
                    placeholder="Email" #contactemail="ngModel"
                    [ngClass]="{ 'is-invalid':profileForm.submitted && contactemail.invalid }" required email>
                <div *ngIf="profileForm.submitted && contactemail.invalid" class="invalid-feedback">
                    <div *ngIf="contactemail.errors.required">{{ 'validations.emailRequired' | translate }}</div>
                    <div *ngIf="contactemail.errors.email">{{ 'validations.emailValid' | translate }}</div>
                </div>
            </div>
            -->
            <div class="form-group col-12">
                <input type="text" [(ngModel)]="profile?.attributes.field_entidad" name="entity"
                    id="profile-user-entity" class="profile-user-entity form-control"
                    placeholder="{{ 'layout.editProfile.entity' | translate }}" #entity="ngModel"
                    [ngClass]="{ 'is-invalid': profileForm.submitted && entity.invalid }" required>
                <div *ngIf="profileForm.submitted && entity.invalid" class="invalid-feedback">
                    <div *ngIf="entity.errors.required">{{ 'validations.required' | translate }}</div>
                </div>
            </div>
            <div class="form-group col-12">
                <input type="text" [(ngModel)]="profile?.attributes.field_departamento" name="department"
                    id="profile-user-department" class="profile-user-department form-control"
                    placeholder="{{ 'layout.editProfile.department' | translate }}" #department="ngModel"
                    [ngClass]="{ 'is-invalid': profileForm.submitted && department.invalid }" required>
                <div *ngIf="profileForm.submitted && department.invalid" class="invalid-feedback">
                    <div *ngIf="department.errors.required">{{ 'validations.required' | translate }}</div>
                </div>
            </div>

            <div class="custom-file form-group col-12" *ngIf="!previewImage">
                <input type="file" class="custom-file-input" accept='image/*' (change)="preview($event)"
                    id="customFile">
                <label class="custom-file-label">{{ 'layout.editProfile.image' | translate }}</label>
            </div>
            <div id="profile-image-preview" class="form-group col-12" *ngIf="previewImage">
                <div class="d-flex align-items-center">
                    <img id="profile-image-src" [src]="previewImage" [attr.alt]="profileImage?.name"
                        class="form-control">
                    <button type="button" class="btn btn-icon btn-pure danger height-40 ml-2" (click)="removeImage()"
                        title="{{ 'layout.editProfile.removeImage' | translate }}">
                        <i class="la la-trash"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="form-group position-relative mb-0 flex-grow-1">
                <div *ngIf="errorMessage" class="alert alert-danger mb-0" [innerHTML]="errorMessage"></div>
            </div>
            <div class="form-group position-relative has-icon-left mb-0">
                <button type="submit" class="btn btn-primary" [disabled]="submitting ? true : null"><i
                        [ngClass]="{ 'fa fa-refresh fa-spin': submitting, 'd-none': !submitting }"></i> {{
                    'layout.editProfile.updateProfile' | translate }}</button>
            </div>
        </div>
    </form>
</ng-template>